import * as $ from 'jquery';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NavigationComponent } from './shared/header-navigation/navigation.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { RightSidebarComponent } from './shared/right-sidebar/rightsidebar.component';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { AuthService } from './.providers/auth.service';
import { LoginPageComponent } from './login-page/login-page.component';
import { HomePageComponent } from './home-page/home-page.component';
import { AngularFireModule } from 'angularfire2';
import { environment } from '../environments/environment';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule, AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { NavbarComponent } from './navbar/navbar.component';
import { CreateProjectComponent } from './create-project/create-project.component';
import { UserService } from './.providers/user.service';
import { MainService } from './.providers/main.service';
import { AuthGuard } from './.guard/auth.guard';
import { TagInputModule } from 'ngx-chips';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Firebase Config
export const firebaseConfig = {
	apiKey: 'AIzaSyBM4I-2aTCyLRa-p7giWqg8n8AjNSQun8o',
	authDomain: 'alagatime.firebaseapp.com',
	databaseURL: 'https://alagatime.firebaseio.com',
	projectId: 'alagatime',
	storageBucket: 'alagatime.appspot.com',
	messagingSenderId: '393183833233'
};
const routes: Routes = [
	{ path: '', redirectTo: 'projects', pathMatch: 'full' },
	{ path: 'home', component: HomePageComponent },
	{ path: 'projects', component: CreateProjectComponent },
	{
		path: 'login',
		component: LoginPageComponent
	}
	,
	/*
	{
		path: 'accordion',
		loadChildren: './pages/component/accordion/accordion.module#AccordionModule'
	},
	{
		path: 'alert',
		loadChildren: './pages/component/alert/alert.module#NgAlertModule'
	},
	{
		path: 'carousel',
		loadChildren: './pages/component/carousel/carousel.module#ButtonsModule'
	},
	{
		path: 'datepicker',
		loadChildren: './pages/component/datepicker/datepicker.module#DatepickerModule'
	},
	{
		path: 'dropdown',
		loadChildren: './pages/component/dropdown-collapse/dropdown-collapse.module#DropdownModule'
	},
	{
		path: 'modal',
		loadChildren: './pages/component/modal/modal.module#ModalModule'
	},
	{
		path: 'pagination',
		loadChildren: './pages/component/pagination/pagination.module#paginationModule'
	},
	{
		path: 'Popovertooltip',
		loadChildren: './pages/component/popover-tooltip/popover-tooltip.module#PopoverTooltipModule'
	},
	{
		path: 'progressbar',
		loadChildren: './pages/component/progressbar/progressbar.module#progressbarModule'
	},
	{
		path: 'rating',
		loadChildren: './pages/component/rating/rating.module#RatingModule'
	},
	{
		path: 'tabs',
		loadChildren: './pages/component/tabs/tabs.module#TabsModule'
	},
	{
		path: 'timepicker',
		loadChildren: './pages/component/timepicker/timepicker.module#TimepickerModule'
	},
	{
		path: 'typehead',
		loadChildren: './pages/component/typehead/typehead.module#TypeheadModule'
	},
	{
		path: 'fontawesome',
		loadChildren: './pages/icons/fontawesome/fontawesome.module#FontawesomeModule'
	},
	{
		path: 'simpleline',
		loadChildren: './pages/icons/simpleline/simpleline.module#SimplelineIconModule'
	},
	{
		path: 'material',
		loadChildren: './pages/icons/material/material.module#MaterialComponentModule'
	},*/
	// otherwise redirect to home
	{ path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
	declarations: [
		AppComponent,
		LoginPageComponent,
		HomePageComponent,
		NavbarComponent,
		CreateProjectComponent,
		NavigationComponent,
		BreadcrumbComponent,
		SidebarComponent,
		RightSidebarComponent
	],
	imports: [
		BrowserAnimationsModule,
		TagInputModule,
		BrowserModule,
		FormsModule,
		HttpModule,
		AngularFireModule.initializeApp(firebaseConfig),
		AngularFireAuthModule,
		NgbModule.forRoot(),
		RouterModule.forRoot(routes)
	],
	providers: [AuthService, AngularFireDatabase, UserService, MainService, AuthGuard],
	bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/OneDrive/Dev/firebase/alagatime_bootstrap/src/app/app.module.ts